import CryptoJS from 'crypto-js';
import packageJson from '../../package.json';

const DEFAULT_SECRET = 'spbi-external-bootstrap-v1';
const BOOTSTRAP_FLAG_KEY = 'bootstrapSupplierLogin';

function getBootstrapSecret() {
  return process.env.VUE_APP_SPBI_EXTERNAL_BOOTSTRAP_SECRET || DEFAULT_SECRET;
}

function parseBootstrapPayload(token) {
  if (!token) {
    return null;
  }

  try {
    const decrypted = CryptoJS.AES.decrypt(token, getBootstrapSecret()).toString(CryptoJS.enc.Utf8);
    if (!decrypted) {
      return null;
    }

    const payload = JSON.parse(decrypted);
    if (!payload || !payload.authKey || !Array.isArray(payload.supplierList)) {
      return null;
    }

    if (!payload.expiresAt || Number(payload.expiresAt) < Date.now()) {
      return null;
    }

    return payload;
  } catch (error) {
    console.log('Error ExternalLoginBootstrapService.parseBootstrapPayload', error);
    return null;
  }
}

class ExternalLoginBootstrapService {
  parseToken(token) {
    return parseBootstrapPayload(token);
  }

  saveBootstrapSession(payload) {
    sessionStorage.setItem('authKey', payload.authKey);
    sessionStorage.setItem('list', JSON.stringify(payload.supplierList));
    sessionStorage.setItem('fe-version', packageJson.version);
    sessionStorage.setItem(BOOTSTRAP_FLAG_KEY, 'true');
  }

  restoreBootstrapSession() {
    if (sessionStorage.getItem(BOOTSTRAP_FLAG_KEY) !== 'true') {
      return null;
    }

    const authKey = sessionStorage.getItem('authKey');
    const companies = sessionStorage.getItem('list');
    if (!authKey || !companies) {
      return null;
    }

    try {
      const supplierList = JSON.parse(companies);
      if (!Array.isArray(supplierList)) {
        return null;
      }

      return {
        authKey,
        supplierList,
      };
    } catch (error) {
      console.log('Error ExternalLoginBootstrapService.restoreBootstrapSession', error);
      return null;
    }
  }

  clearBootstrapSession() {
    sessionStorage.removeItem(BOOTSTRAP_FLAG_KEY);
  }
}

export default new ExternalLoginBootstrapService();
